export const getManifestationCitationInfo = (transcriptionid: string) => {
  var query = [
  "SELECT DISTINCT ?manifestation ?manifestationTitle ?manifestationSurface ?surfaceTitle ?codexTitle ?datasource ?eLongTitle ?author ?authorTitle ?expression ?editor ?editorTitle ?docsource ?structureType",
  "{",
  "<" + transcriptionid + "> <http://scta.info/property/isTranscriptionOf> ?manifestation .",
  "<" + transcriptionid + "> <http://scta.info/property/hasXML> ?datasource . ",
  "OPTIONAL {",
  "<" + transcriptionid + "> <http://scta.info/property/hasDocument> ?docsource . ",
  "}",
  "<" + transcriptionid + "> <http://scta.info/property/structureType> ?structureType . ",
  "?manifestation <http://purl.org/dc/elements/1.1/title> ?manifestationTitle .",
  "{",
   "?manifestation <http://scta.info/property/isPartOfTopLevelManifestation> ?topLevelManifestation .",
  "}",
  "UNION",
  "{",
   "?manifestation <http://scta.info/property/level> '1' .",
   "BIND (?manifestation AS ?topLevelManifestation) .",
  "}",
  "OPTIONAL {",
    "?topLevelManifestation <http://scta.info/property/editor> ?editor .",
    "?editor <http://purl.org/dc/elements/1.1/title> ?editorTitle .",
  "}",
  "?manifestation <http://scta.info/property/isManifestationOf> ?expression .",
  "{",
  "?expression <http://scta.info/property/isPartOfTopLevelExpression> ?topLevelExpression .",
  "}",
  "UNION",
  "{",
   "?expression <http://scta.info/property/level> '1' .",
   "BIND (?expression AS ?topLevelExpression) .",
  "}",
  "OPTIONAL {",
   "?expression <http://scta.info/property/longTitle> ?eLongTitle",
 "}",
  "OPTIONAL {",
    "?topLevelExpression <http://www.loc.gov/loc.terms/relators/AUT> ?author .",
    "?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .",
  "}",
  // # TODO isOnSurface should become more uniform across manifestations in order to simplify this
  "OPTIONAL",
    "{",
    // #option 1 get surfaces for elements and blocks
     "{",
       "?manifestation <http://scta.info/property/isOnZone> ?bn . ",
       "?bn <http://scta.info/property/isOnZone> ?zone .",
       "?zone <http://scta.info/property/isPartOfSurface> ?manifestationSurface .",
     "}",
     "UNION",
     //#option 2 get surface for divisions and items
     "{",
       "?manifestation <http://scta.info/property/hasStructureBlock> ?block .",
       "?block <http://scta.info/property/isOnSurface> ?manifestationSurface .",
     "}",
     "UNION",
     //#option 3 get surfaces for collections"
     "{",
       "?manifestation <http://scta.info/property/hasStructureItem> ?item .",
       "?item <http://scta.info/property/isOnSurface> ?manifestationSurface .",
     "}",
     "?manifestationSurface <http://purl.org/dc/elements/1.1/title> ?surfaceTitle .",
     "?manifestationSurface <http://scta.info/property/order> ?surface_order .",
     "?codex <http://scta.info/property/hasSurface> ?manifestationSurface .",
     "?codex <http://purl.org/dc/elements/1.1/title> ?codexTitle .",
    "}",
  "}",
  "ORDER BY ?surface_order"].join('');
  return query
}